module.exports = __webpack_public_path__ + "static/index/img/baikal-805.6d1f5a01.jpg";